import type { CbiFrontendServiceContext } from "../../frontend/context/CbiFrontendServiceContext";
import type { RoleAssignmentStaff } from "./RoleAssignmentStaff";
import type { TrackedBase } from "./TrackedBase";
import type { UserDTOBase } from "./UserDTOBase";
import type { UserPermissionStaff } from "./UserPermissionStaff";

export class UserStaff implements UserDTOBase, TrackedBase {
  constructor(public readonly userId: number, public readonly userName: string, public readonly email: string, public readonly locked: boolean | null, public readonly pwChangeReqd: boolean | null, public readonly nameFirst: string | null, public readonly nameLast: string | null, public readonly sageToAdd: string | null, public readonly active: boolean, public readonly hideFromClose: boolean | null, public readonly pwHashScheme: string | null, public readonly userType: string | null, public readonly noAppAccess: boolean | null, public readonly roleAssignments: Array<RoleAssignmentStaff> | null, public readonly permissions: Array<UserPermissionStaff> | null, public readonly createdOn: Date | null, public readonly createdBy: string | null, public readonly updatedOn: Date | null, public readonly updatedBy: string | null) {
    this.cbiServiceContext = null;
    this.roleAssignmentsLoaded = this.roleAssignments != null;
    this.roleAssignmentsCached = this.roleAssignments;
    this.permissionsLoaded = this.permissions != null;
    this.permissionsCached = this.permissions;
  }
  cbiServiceContext: CbiFrontendServiceContext | null;
  private roleAssignmentsLoaded: boolean;
  private roleAssignmentsCached: Array<RoleAssignmentStaff> | null;
  private permissionsLoaded: boolean;
  private permissionsCached: Array<UserPermissionStaff> | null;
  async roleAssignmentsLazy(): Promise<Array<RoleAssignmentStaff>> {
    if (!this.roleAssignmentsLoaded) {
      this.roleAssignmentsCached = await this.cbiServiceContext!.userService().getUserStaffRoleAssignments(this.userId);
      this.roleAssignmentsLoaded = true;
    }
    return this.roleAssignmentsCached!;
  }
  async permissionsLazy(): Promise<Array<UserPermissionStaff>> {
    if (!this.permissionsLoaded) {
      this.permissionsCached = await this.cbiServiceContext!.userService().getUserStaffPermissions(this.userId);
      this.permissionsLoaded = true;
    }
    return this.permissionsCached!;
  }
}
